// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__xNzFY","title":"ClientCherryInfo_title__1vzj4","itemText":"ClientCherryInfo_itemText__1k8gR"};